export enum FactionEnum {
  RUSSIANARMY = "RussianArmy",
  HOSPITAL = "Hospital",
  MEDSI = "Medsi",
  REGION24 = "Region24",
}
